'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withSearchInput = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _recompose = require('recompose');

var withSearchInput = exports.withSearchInput = function withSearchInput(Component) {
  return (0, _recompose.compose)((0, _recompose.withState)('search', 'setSearch', function (_ref) {
    var _ref$term = _ref.term,
        term = _ref$term === undefined ? '' : _ref$term;
    return { term: term };
  }), (0, _recompose.withHandlers)({
    onChangeTerm: function onChangeTerm(_ref2) {
      var setSearch = _ref2.setSearch;
      return function (event) {
        event.preventDefault();
        var term = event.target.value;
        setSearch(function (state) {
          var newState = _extends({}, state, { term: term });
          return newState;
        });
      };
    },
    onClearTerm: function onClearTerm(_ref3) {
      var setSearch = _ref3.setSearch,
          changeSearch = _ref3.changeSearch;
      return function (event) {
        event.preventDefault();
        setSearch(function (state) {
          var newState = _extends({}, state, { term: '' });
          changeSearch(newState);
          return newState;
        });
      };
    },
    onCommitTerm: function onCommitTerm(_ref4) {
      var search = _ref4.search,
          changeSearch = _ref4.changeSearch;
      return function (event) {
        event.preventDefault();
        changeSearch(search);
      };
    }
  }))(Component);
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/de-search-input/with-search-input.js
// module id = 2023
// module chunks = 0